module.exports = __webpack_public_path__ + "img/04.6f9854c5.svg";